import React, { Component } from 'react';
import FormError from '../../models/FormError';
import ErrorFieldMessage from './FieldErrorMessage.Component';

type TextAreaProps = {
    name: string,
    label: string,
    placeholder: string,
    value?: string,
    errors?: FormError[],
    id: string,

    onChange: (name: string, value: string) => Promise<FormError[]>,
}

type TextAreaState = {
    value: string,
    errors: FormError[]
}

export default class TextArea extends Component<TextAreaProps, TextAreaState> {
    constructor(props: TextAreaProps) {
        super(props);

        this.state = {
            value: "",
            errors: props.errors?.filter(err => { return err.field === props.name }) ?? []
        }
    }

    public componentDidUpdate(previousProps: TextAreaProps, previousState: TextAreaState) {
        if (this.props.errors?.length != previousProps.errors?.length) {
            this.setState({
                errors: this.props.errors?.filter(err => { return err.field === this.props.name }) ?? []
            });
        }
    }

    public async onChange(value: string) {
        const errors = await this.props.onChange(this.props.name, value);

        this.setState({
            value: value,
            errors: errors
        })
    }

    public render() {
        return <div className="form-group">
            <label htmlFor={this.props.id}>{this.props.label}</label>
            <textarea id={this.props.id} className={"form-control" + (this.state.errors.length > 0 ? " is-invalid" : "")} name={this.props.name} onBlur={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                this.onChange(event.target.value)
            }} placeholder={this.props.placeholder} />
            <ErrorFieldMessage name={this.props.name} errors={this.state.errors}></ErrorFieldMessage>
        </div>
    }
}